import * as React from "react";
import { Card, CardContent, Typography, Box, Link, Grid } from "@mui/material";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
export default function ContentCard({
  firstImage,
  Title,
  Subtitle,
  buttonName,
  sideImage1,
  sideImage2,
  topImage1,
  topImage2,
  onClick
}) {
  return (
    <>
      <Card
        sx={{
          display: "flex",
          alignItems: "center",
          p: 2,
          borderRadius: 3,
          boxShadow: "0px 0px 3.81px rgba(0, 0, 0, 0.25)",

          // maxWidth: 320,
          border: "1px solid #EAE3E3",
          position: "relative",
        }}
      >
        {/* Icon Section */}
        <Box position="absolute" right={0} top={0}>
          {sideImage1}
        </Box>
        <Box position="absolute" right={0} bottom={0}>
          {sideImage2}
        </Box>
        <Box position="absolute" right={0} top={0}>
          {topImage1}
        </Box>
        <Box position="absolute" right={0} top={0}>
          {topImage2}
        </Box>
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <Box width={65}>{firstImage}</Box>
          </Grid>
          {/* Text Section */}
          <Grid item xs={9} zIndex={1}>
            <Typography
              fontFamily="Inter"
              color="#252525"
              sx={{ fontWeight: 700, fontSize: "16px" }}
            >
              {Title}
            </Typography>
            <Typography
              fontFamily="Inter"
              mt={1}
              sx={{ fontWeight: 500, color: "#000000", fontSize: "12px" }}
            >
              {Subtitle}
            </Typography>
            <Box display="flex" alignItems="center" gap={1} mt={1}>
              <Typography
                fontFamily="Inter"
                color="#572575"
                onClick={onClick}
                sx={{ fontWeight: 600, fontSize: "14px" , cursor:"pointer"}}
              >
                {buttonName}
              </Typography>
              <Box width={6}>
                {" "}
                <img src="/newdashboard/Taskandnenrollcard/Vector (4).png" />
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Card>
    </>
  );
}
